module.exports = __webpack_public_path__ + "static/media/sample_rake_upload.252dfc9a.csv";